import { render, staticRenderFns } from "./ProjectListPage.vue?vue&type=template&id=45eb4129&scoped=true&"
import script from "./ProjectListPage.vue?vue&type=script&lang=js&"
export * from "./ProjectListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb4129",
  null
  
)

export default component.exports